import { Image, Modal } from "react-bootstrap"

const ImageZoomViewer = (props: { showModal: boolean, onHide: () => void, image: string }) => {
    return (
        <Modal show={props.showModal} onHide={props.onHide} centered size="lg">
            <Modal.Body>
                <Image src={props.image} className='img-fluid rounded' style={{ maxHeight: '100%', maxWidth: '100%' }} />
            </Modal.Body>
        </Modal>
    )

}

export default ImageZoomViewer